<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-sm-9">
            <h5 class="card-title">Retterstatus</h5>
          </div>
          <div class="col-sm-3 text-right" v-if="canManageCriteria">
            <p-button type="default" class="mt-0" @click="openCriteriaDialog">
              <i class="bi bi-list-check"></i> Prüfkriterien
            </p-button>
          </div>
        </div>
      </div>
      <div class="card-body row">
        <div class="col-sm-12">
          <el-table
            :data="filteredTrainer"
            header-row-class-name="text-primary"
            empty-text="Es konnten keine Mitarbeiter gefunden werden."
            v-loading="loading"
          >
            <el-table-column prop="trainerName" label="Name" min-width="110"></el-table-column>
            <el-table-column
              prop="trainerLetztePruefung"
              label="Letzte Prüfung"
              min-width="150"
            >
            </el-table-column>
            <el-table-column prop="status" label="Status" min-width="75">
              <template slot-scope="scope">
                <div v-if="scope.row.status == 1" class="text-left">
                  <i
                    class="bi bi-check-circle-fill"
                    style="font-size: 1.2rem; color: green"
                  ></i>
                </div>
                <div v-else-if="scope.row.status == 2" class="text-left">
                  <i
                    class="bi bi-exclamation-triangle-fill"
                    style="font-size: 1.2rem; color: orange"
                  ></i>
                </div>
                <div v-else-if="scope.row.status == 3" class="text-left">
                  <i
                    class="bi bi-exclamation-triangle-fill"
                    style="font-size: 1.2rem; color: red"
                  ></i>
                </div>
                <div v-else-if="scope.row.status == 4" class="text-left">
                  <i
                    class="bi bi-check-circle-fill"
                    style="font-size: 1.2rem; color: blue"
                  ></i>
                </div>
                <div v-else class="text-left">-</div>
              </template>
            </el-table-column>
            <el-table-column prop="trainerPruefer" label="Prüfer" min-width="120">
            </el-table-column>
            <el-table-column prop="ersteHilfeKursDatum" label="Erste-Hilfe-Kurs" min-width="120">
              <template slot-scope="scope">
                <span
                  v-if="scope.row.ersteHilfeKursDatum != '-' && scope.row.ersteHilfeKursExpired == false"
                >
                  {{ scope.row.ersteHilfeKursDatum }}
                </span>
                <span
                  v-else-if="scope.row.ersteHilfeKursDatum != '-' && scope.row.ersteHilfeKursExpired == true"
                  style="color: red; font-weight: bold;"
                >
                  {{ scope.row.ersteHilfeKursDatum }}
                </span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column
              class-name="action-buttons td-actions"
              align="right"
              label=""
              min-width="170"
            >
              <template slot="header" slot-scope="scope">
                <el-input
                  v-model="search"
                  size="mini"
                  placeholder="Mitarbeiter suchen..."
                >
                  <i slot="prefix" class="bi bi-search"></i>
                </el-input>
              </template>
              <template slot-scope="props">
                <div class="retterstatus-action-buttons">
                  <el-tooltip content="Prüfungsverlauf" placement="top">
                    <p-button
                      type="info"
                      size="sm"
                      icon
                      @click="openHistoryDialog(props.row)"
                    >
                      <i class="bi bi-clock-history"></i>
                    </p-button>
                  </el-tooltip>
                  <el-tooltip content="Neue Prüfung" placement="top" v-if="retterpruefungRole">
                    <p-button
                      type="success"
                      size="sm"
                      icon
                      @click="openAddCheckDialog(props.row)"
                    >
                      <i class="fa fa-edit"></i>
                    </p-button>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <modal
      :show.sync="modals.addCheck"
      headerClasses="justify-content-center"
      bodyClasses="retterstatus-modal-body"
      modalMaxWidth="1000px"
      @close="closeAddCheckDialog"
    >
      <h5 slot="header" class="title mb-0">
        Prüfung von {{ selectedTrainer ? selectedTrainer.trainerName : '' }}
      </h5>

      <div class="row">
        <div class="col-md-4">
          <label class="col-form-label">Prüfungsdatum</label>
          <el-date-picker
            v-model="newCheckDate"
            type="date"
            placeholder="Datum wählen"
            :picker-options="pickerOptions1"
            format="dd.MM.yyyy"
          >
          </el-date-picker>
        </div>
        <div class="col-md-4">
          <label class="col-form-label">Prüfer</label>
          <el-select
            class="select w-100"
            placeholder="Prüfer wählen"
            filterable
            v-model="newCheckPruefer"
          >
            <el-option
              v-for="option in HT"
              class="select"
              :value="option.HTname"
              :label="option.HTname"
              :key="option.HTname"
            >
            </el-option>
          </el-select>
        </div>
        <div class="col-md-4">
          <label class="col-form-label">Rettungsart</label>
          <el-radio-group v-model="newCheckRescueType" class="w-100 retterstatus-radio-group">
            <el-radio-button label="Passivrettung"></el-radio-button>
            <el-radio-button label="Aktivrettung"></el-radio-button>
          </el-radio-group>
        </div>
      </div>

      <div class="retterstatus-section mt-4">
        <div class="d-flex justify-content-between align-items-center flex-wrap">
          <div>
            <h6 class="mb-1">Prüfkriterien</h6>
            <p class="text-muted mb-0">
              Markiere alle Kriterien, die <b>nicht erfüllt</b> wurden. Zulässig sind maximal 6 Fehlerpunkte.
            </p>
          </div>
          <div class="retterstatus-summary mt-2 mt-md-0">
            <span class="retterstatus-summary-item">Fehlerpunkte: <b>{{ totalErrorPoints }}</b> / 6</span>
            <span
              class="retterstatus-result"
              :class="isCheckPassed ? 'retterstatus-result-success' : 'retterstatus-result-danger'"
            >
              {{ isCheckPassed ? 'Bestanden' : 'Nicht bestanden' }}
            </span>
          </div>
        </div>

        <div v-if="criteriaLoading" class="retterstatus-empty-state">
          Prüfkriterien für Standort {{ location }} werden geladen...
        </div>
        <div v-else-if="criteria.length === 0" class="alert alert-warning mt-3 mb-0">
          Für den Standort sind keine Prüfkriterien hinterlegt.
        </div>
        <div v-else class="row mt-3">
          <div class="col-md-6 mb-2" v-for="group in groupedCriteria" :key="group.category">
            <div class="retterstatus-criteria-group">
              <h6 class="retterstatus-criteria-title">{{ group.category }}</h6>
              <div
                class="retterstatus-criteria-item"
                v-for="criterion in group.items"
                :key="criterion.localId"
              >
                <label class="mb-0 retterstatus-checkbox-label">
                  <input
                    type="checkbox"
                    :value="criterion.localId"
                    v-model="failedCriteriaIds"
                    class="mr-2"
                  >
                  <span>{{ criterion.criterion }}</span>
                  <small class="text-muted d-block">{{ criterion.errorPoints }} Fehlerpunkte</small>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="retterstatus-section mt-4">
        <div class="d-flex justify-content-between align-items-center flex-wrap">
          <div>
            <h6 class="mb-1">Stoppuhr</h6>
            <p class="text-muted mb-0">
              Zwischenzeiten für Aufstieg, Rettung und Retter am Boden festhalten.
              <span v-if="requiresLoryTime"> In NB zusätzlich Lory-Aufstieg.</span>
            </p>
            <label class="retterstatus-toggle mt-2 mb-0">
              <input v-model="useStopwatch" type="checkbox" @change="handleStopwatchToggleChange">
              <span>Zeiterfassung verwenden</span>
            </label>
          </div>
          <div class="retterstatus-stopwatch-display" :class="{ 'retterstatus-stopwatch-display-disabled': !useStopwatch }">
            {{ stopwatchDisplay }}
          </div>
        </div>

        <div class="retterstatus-stopwatch-controls mt-3">
          <p-button type="success" class="mt-0" @click="toggleStopwatch" :disabled="!useStopwatch">
            <i :class="stopwatchRunning ? 'bi bi-pause-fill' : 'bi bi-play-fill'"></i>
            {{ stopwatchRunning ? 'Pause' : stopwatchElapsedMs > 0 ? 'Fortsetzen' : 'Start' }}
          </p-button>
          <p-button type="default" class="mt-0" @click="resetStopwatch" :disabled="!useStopwatch">
            <i class="bi bi-arrow-counterclockwise"></i>
            Zurücksetzen
          </p-button>
        </div>

        <div class="row mt-3">
          <div class="col-md-3">
            <div class="retterstatus-split-card">
              <div class="retterstatus-split-label">Aufstieg</div>
              <div class="retterstatus-split-value">{{ getSplitDisplay('ascent') }}</div>
              <el-input
                v-model="splitInputValues.ascent"
                class="mt-2"
                placeholder="mm:ss.xx"
                @input="handleSplitInput('ascent')"
              ></el-input>
              <small v-if="splitInputErrors.ascent" class="retterstatus-split-error">
                Bitte Zeit als mm:ss.xx eingeben.
              </small>
              <p-button
                type="info"
                size="sm"
                class="mt-2"
                block
                @click="recordSplit('ascent')"
                :disabled="!useStopwatch || !stopwatchElapsedMs"
              >
                Zeit übernehmen
              </p-button>
            </div>
          </div>
          <div class="col-md-3">
            <div class="retterstatus-split-card">
              <div class="retterstatus-split-label">Rettung</div>
              <div class="retterstatus-split-value">{{ getSplitDisplay('rescue') }}</div>
              <el-input
                v-model="splitInputValues.rescue"
                class="mt-2"
                placeholder="mm:ss.xx"
                @input="handleSplitInput('rescue')"
              ></el-input>
              <small v-if="splitInputErrors.rescue" class="retterstatus-split-error">
                Bitte Zeit als mm:ss.xx eingeben.
              </small>
              <p-button
                type="info"
                size="sm"
                class="mt-2"
                block
                @click="recordSplit('rescue')"
                :disabled="!useStopwatch || !stopwatchElapsedMs"
              >
                Zeit übernehmen
              </p-button>
            </div>
          </div>
          <div class="col-md-3">
            <div class="retterstatus-split-card">
              <div class="retterstatus-split-label">Retter am Boden</div>
              <div class="retterstatus-split-value">{{ getSplitDisplay('rescuerGround') }}</div>
              <el-input
                v-model="splitInputValues.rescuerGround"
                class="mt-2"
                placeholder="mm:ss.xx"
                @input="handleSplitInput('rescuerGround')"
              ></el-input>
              <small v-if="splitInputErrors.rescuerGround" class="retterstatus-split-error">
                Bitte Zeit als mm:ss.xx eingeben.
              </small>
              <p-button
                type="info"
                size="sm"
                class="mt-2"
                block
                @click="recordSplit('rescuerGround')"
                :disabled="!useStopwatch || !stopwatchElapsedMs"
              >
                Zeit übernehmen
              </p-button>
            </div>
          </div>
          <div class="col-md-3" v-if="requiresLoryTime">
            <div class="retterstatus-split-card">
              <div class="retterstatus-split-label">Lory-Aufstieg</div>
              <div class="retterstatus-split-value">{{ getSplitDisplay('loryAscent') }}</div>
              <el-input
                v-model="splitInputValues.loryAscent"
                class="mt-2"
                placeholder="mm:ss.xx"
                @input="handleSplitInput('loryAscent')"
              ></el-input>
              <small v-if="splitInputErrors.loryAscent" class="retterstatus-split-error">
                Bitte Zeit als mm:ss.xx eingeben.
              </small>
              <p-button
                type="info"
                size="sm"
                class="mt-2"
                block
                @click="recordSplit('loryAscent')"
                :disabled="!useStopwatch || !stopwatchElapsedMs"
              >
                Zeit übernehmen
              </p-button>
            </div>
          </div>
        </div>

        <div class="retterstatus-summary retterstatus-summary-compact mt-3">
          <span class="retterstatus-summary-item">Gesamtzeit: <b>{{ totalTimeDisplay }}</b></span>
        </div>
      </div>

        <div class="retterstatus-section mt-4">
          <h6 class="mb-2">Anmerkungen</h6>
          <el-input
            v-model="newCheckComment"
            type="textarea"
            :rows="4"
            placeholder="Anmerkungen zur Prüfung (optional)"
          ></el-input>
        </div>

      <template slot="footer">
        <div class="left-side">
          <p-button type="default" link @click="closeAddCheckDialog">Abbrechen</p-button>
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button type="success" link @click="addCheck" :disabled="!canSaveCheck">
            {{ saveInProgress ? 'Speichern...' : 'Speichern' }}
          </p-button>
        </div>
      </template>
    </modal>

    <modal
      :show.sync="modals.criteria"
      headerClasses="justify-content-center"
      bodyClasses="retterstatus-modal-body"
      modalMaxWidth="1100px"
      @close="closeCriteriaDialog"
    >
      <h5 slot="header" class="title mb-0">
        Prüfkriterien {{ locationDisplayName }}
      </h5>

      <div class="d-flex justify-content-between align-items-center flex-wrap mb-3">
        <p class="text-muted mb-2 mb-md-0">
          Kriterien für den aktuell gewählten Standort verwalten. Reihenfolge per Drag & Drop ändern.
        </p>
        <div class="retterstatus-action-buttons retterstatus-action-buttons-left">
          <p-button type="success" class="mt-0" @click="addCriteriaRow">
            <i class="bi bi-plus-circle"></i> Kriterium hinzufügen
          </p-button>
        </div>
      </div>

      <div v-if="criteriaDraft.length === 0" class="retterstatus-empty-state">
        Noch keine Kriterien vorhanden.
      </div>
      <div v-else>
        <div class="retterstatus-criteria-admin-header d-none d-md-grid">
          <div></div>
          <div>Kategorie</div>
          <div>Kriterium</div>
          <div>Fehlerpunkte</div>
          <div></div>
        </div>
        <draggable v-model="criteriaDraft" handle=".retterstatus-drag-handle" ghost-class="retterstatus-drag-ghost">
          <div
            class="retterstatus-criteria-admin-row"
            v-for="(criterion, index) in criteriaDraft"
            :key="criterion.localId"
          >
            <div class="retterstatus-drag-column">
              <label class="retterstatus-field-label retterstatus-mobile-only">Reihenfolge</label>
              <button type="button" class="retterstatus-drag-handle" title="Ziehen zum Verschieben">
                <i class="bi bi-grip-vertical"></i>
              </button>
            </div>
            <div>
              <label class="retterstatus-field-label">Kategorie</label>
              <el-select v-model="criterion.category" placeholder="Kategorie" class="w-100">
                <el-option
                  v-for="option in criteriaCategoryOptions"
                  :key="option"
                  :label="option"
                  :value="option"
                ></el-option>
              </el-select>
            </div>
            <div>
              <label class="retterstatus-field-label">Kriterium</label>
              <el-input v-model="criterion.criterion" placeholder="Kriterium"></el-input>
            </div>
            <div>
              <label class="retterstatus-field-label">Fehlerpunkte</label>
              <el-input-number v-model="criterion.errorPoints" :min="0" :max="10" class="w-100"></el-input-number>
            </div>
            <div class="retterstatus-criteria-admin-remove">
              <label class="retterstatus-field-label retterstatus-mobile-only">Aktion</label>
              <p-button type="danger" size="sm" class="mt-0" @click="removeCriteriaRow(index)">
                <i class="bi bi-trash"></i>
              </p-button>
            </div>
          </div>
        </draggable>
      </div>

      <template slot="footer">
        <div class="left-side">
          <p-button type="default" link @click="closeCriteriaDialog">Abbrechen</p-button>
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button type="success" link @click="saveCriteria" :disabled="!isCriteriaDraftValid || criteriaSaveInProgress">
            {{ criteriaSaveInProgress ? 'Speichern...' : 'Speichern' }}
          </p-button>
        </div>
      </template>
    </modal>

    <modal
      :show.sync="modals.history"
      headerClasses="justify-content-center"
      bodyClasses="retterstatus-modal-body"
      modalMaxWidth="900px"
      @close="closeHistoryDialog"
    >
      <h5 slot="header" class="title mb-0">
        Prüfungsverlauf {{ selectedTrainer ? selectedTrainer.trainerName : '' }}
      </h5>

      <div v-if="historyLoading" class="retterstatus-empty-state">
        Prüfungsverlauf wird geladen...
      </div>
      <div v-else-if="historyEntries.length === 0" class="retterstatus-empty-state">
        Für diesen Mitarbeiter wurden noch keine Prüfungen gespeichert.
      </div>
      <div v-else>
        <div class="retterstatus-history-entry" v-for="entry in historyEntries" :key="entry.key">
          <div class="d-flex justify-content-between align-items-start flex-wrap">
            <div>
              <h6 class="mb-1">{{ entry.dateDisplay }}</h6>
              <p class="text-muted mb-0">{{ entry.rescueType }} | Prüfer: {{ entry.pruefer }}</p>
            </div>
            <div class="retterstatus-summary retterstatus-summary-compact mt-2 mt-md-0">
              <span class="retterstatus-summary-item">Fehlerpunkte: <b>{{ entry.totalErrorPoints }}</b> / 6</span>
              <span class="retterstatus-summary-item">Gesamtzeit: <b>{{ entry.totalTimeDisplay }}</b></span>
              <span
                class="retterstatus-result"
                :class="entry.passed ? 'retterstatus-result-success' : 'retterstatus-result-danger'"
              >
                {{ entry.result }}
              </span>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-md-3">
              <div class="retterstatus-history-metric">
                <small class="text-muted d-block">Aufstieg</small>
                <b>{{ entry.times.ascent }}</b>
              </div>
            </div>
            <div class="col-md-3">
              <div class="retterstatus-history-metric">
                <small class="text-muted d-block">Rettung</small>
                <b>{{ entry.times.rescue }}</b>
              </div>
            </div>
            <div class="col-md-3">
              <div class="retterstatus-history-metric">
                <small class="text-muted d-block">Retter am Boden</small>
                <b>{{ entry.times.rescuerGround }}</b>
              </div>
            </div>
            <div class="col-md-3" v-if="entry.times.loryAscent">
              <div class="retterstatus-history-metric">
                <small class="text-muted d-block">Lory-Aufstieg</small>
                <b>{{ entry.times.loryAscent }}</b>
              </div>
            </div>
          </div>

          <div class="mt-3">
            <small class="text-muted d-block mb-2">Nicht erfüllte Kriterien</small>
            <ul v-if="entry.failedCriteria.length" class="mb-0 pl-3">
              <li v-for="criterion in entry.failedCriteria" :key="criterion.key">
                <b>{{ criterion.category }}:</b> {{ criterion.criterion }}
                <span class="text-muted">({{ criterion.errorPoints }} FP)</span>
              </li>
            </ul>
            <p v-else class="mb-0">Keine Kriterien markiert.</p>
          </div>

          <div class="mt-3" v-if="entry.comment">
            <small class="text-muted d-block mb-2">Anmerkung</small>
            <p class="mb-0 retterstatus-history-comment">{{ entry.comment }}</p>
          </div>
        </div>
      </div>

      <template slot="footer">
        <div class="left-side"></div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button type="default" link @click="closeHistoryDialog">Schließen</p-button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import Vue from "vue";
import { db } from "../../../../firebaseDb";
import { Table, TableColumn, Tooltip, DatePicker, TimeSelect, Select, Option, Input, InputNumber, Loading, RadioGroup, RadioButton } from "element-ui";
import moment from "moment-timezone";
import { Modal } from "src/components/UIComponents";
import store from "../../../../store";
import criteriaSeedData from "../../../../data/retterpruefungskriterien.seed.json";
import draggable from "vuedraggable";

Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Tooltip);
Vue.use(DatePicker);
Vue.use(TimeSelect);
Vue.use(Loading);

const MAX_ERROR_POINTS = 6;
const LOCATION_NAMES = {
  DA: "Darmstadt",
  NB: "Neroberg",
  FRA: "Frankfurt",
};
const CRITERIA_CATEGORY_OPTIONS = [
  "Einbau",
  "Aufstieg",
  "Elementrettung",
  "Plattformrettung",
  "Aktivrettung",
  "Abseilen",
  "Sonstiges",
];

export default {
  components: {
    Modal,
    draggable,
    [Select.name]: Select,
    [Option.name]: Option,
    [Input.name]: Input,
    [InputNumber.name]: InputNumber,
    [RadioGroup.name]: RadioGroup,
    [RadioButton.name]: RadioButton,
  },

  data() {
    return {
      trainer: [],
      HT: [],
      criteria: [],
      historyEntries: [],
      search: "",
      location: store.getters.userlocation,
      loading: true,
      criteriaLoading: false,
      historyLoading: false,
      criteriaSaveInProgress: false,
      saveInProgress: false,
      trainerUnsubscribe: null,
      htUnsubscribe: null,
      criteriaUnsubscribe: null,
      locationUnwatch: null,
      modals: {
        addCheck: false,
        criteria: false,
        history: false,
      },
      criteriaDraft: [],
      selectedTrainer: null,
      newCheckDate: null,
      newCheckPruefer: null,
      newCheckComment: "",
      newCheckRescueType: "Passivrettung",
      useStopwatch: true,
      failedCriteriaIds: [],
      stopwatchElapsedMs: 0,
      stopwatchStartedAt: null,
      stopwatchIntervalId: null,
      stopwatchRunning: false,
      stopwatchSplits: {
        loryAscent: null,
        ascent: null,
        rescue: null,
        rescuerGround: null,
      },
      splitInputValues: {
        loryAscent: "",
        ascent: "",
        rescue: "",
        rescuerGround: "",
      },
      splitInputErrors: {
        loryAscent: false,
        ascent: false,
        rescue: false,
        rescuerGround: false,
      },
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        firstDayOfWeek: 1,
        shortcuts: [
          {
            text: "Heute",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
        ],
      },
    };
  },

  computed: {
    filteredTrainer() {
      return this.trainer.filter(
        (data) =>
          !this.search ||
          data.trainerName.toLowerCase().includes(this.search.toLowerCase())
      );
    },
    groupedCriteria() {
      const groups = {};
      this.criteria.forEach((criterion) => {
        if (!groups[criterion.category]) {
          groups[criterion.category] = [];
        }
        groups[criterion.category].push(criterion);
      });

      return Object.keys(groups)
        .sort((left, right) => {
          const leftIndex = this.criteriaCategoryOptions.indexOf(left);
          const rightIndex = this.criteriaCategoryOptions.indexOf(right);
          const normalizedLeftIndex = leftIndex === -1 ? Number.MAX_SAFE_INTEGER : leftIndex;
          const normalizedRightIndex = rightIndex === -1 ? Number.MAX_SAFE_INTEGER : rightIndex;

          if (normalizedLeftIndex !== normalizedRightIndex) {
            return normalizedLeftIndex - normalizedRightIndex;
          }

          return left.localeCompare(right);
        })
        .map((category) => ({
          category,
          items: groups[category].sort((left, right) => left.sortOrder - right.sortOrder),
        }));
    },
    selectedFailedCriteria() {
      return this.criteria.filter((criterion) =>
        this.failedCriteriaIds.includes(criterion.localId)
      );
    },
    totalErrorPoints() {
      return this.selectedFailedCriteria.reduce(
        (sum, criterion) => sum + criterion.errorPoints,
        0
      );
    },
    isCheckPassed() {
      return this.totalErrorPoints <= MAX_ERROR_POINTS;
    },
    requiresLoryTime() {
      return this.location === "NB";
    },
    stopwatchDisplay() {
      if (!this.useStopwatch) {
        return "-";
      }
      return this.formatDuration(this.stopwatchElapsedMs);
    },
    totalTimeDisplay() {
      if (!this.useStopwatch) {
        return "-";
      }
      const totalMs = this.getFinalSplitValue() || this.stopwatchElapsedMs;
      return totalMs ? this.formatDuration(totalMs) : "-";
    },
    locationDisplayName() {
      return LOCATION_NAMES[this.location] || this.location;
    },
    criteriaCategoryOptions() {
      return CRITERIA_CATEGORY_OPTIONS;
    },
    currentUserName() {
      return store.getters.user && store.getters.user.data
        ? store.getters.user.data.displayName || ""
        : "";
    },
    userRole() {
      return store.getters.userrole;
    },
    retterpruefungRole() {
      return Boolean(store.getters.retterpruefungRole);
    },
    canSaveCheck() {
      return Boolean(
        this.selectedTrainer &&
          this.newCheckDate &&
          this.newCheckPruefer &&
          this.criteria.length > 0 &&
          !this.criteriaLoading &&
          !this.hasSplitInputErrors() &&
          !this.saveInProgress
      );
    },
    canManageCriteria() {
      return this.userRole == 2 || this.userRole == 3;
    },
    isCriteriaDraftValid() {
      return this.criteriaDraft.length > 0 && this.criteriaDraft.every(
        (criterion) =>
          String(criterion.category || "").trim() &&
          String(criterion.criterion || "").trim() &&
          Number.isFinite(Number(criterion.errorPoints)) &&
          Number.isFinite(Number(criterion.sortOrder))
      );
    },
  },

  created() {
    console.log("Retterpruefung claim: ", store.getters.retterpruefungRole);
    this.refreshForLocation();
    this.locationUnwatch = store.watch(
      (state) => state.userlocation,
      () => {
        this.refreshForLocation();
      }
    );
  },

  beforeDestroy() {
    this.teardownSnapshots();
    if (this.locationUnwatch) {
      this.locationUnwatch();
    }
    this.pauseStopwatch();
  },

  methods: {
    refreshForLocation() {
      this.location = store.getters.userlocation;
      this.loadData();
      this.loadCriteria();
      this.closeCriteriaDialog();
    },
    teardownSnapshots() {
      if (this.trainerUnsubscribe) {
        this.trainerUnsubscribe();
        this.trainerUnsubscribe = null;
      }
      if (this.htUnsubscribe) {
        this.htUnsubscribe();
        this.htUnsubscribe = null;
      }
      if (this.criteriaUnsubscribe) {
        this.criteriaUnsubscribe();
        this.criteriaUnsubscribe = null;
      }
    },
    toDate(value) {
      if (!value) {
        return null;
      }
      if (typeof value.toDate === "function") {
        return value.toDate();
      }
      if (value.seconds) {
        return new Date(value.seconds * 1000);
      }
      if (value instanceof Date) {
        return value;
      }
      const parsedDate = new Date(value);
      return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
    },
    loadData() {
      this.loading = true;

      if (this.trainerUnsubscribe) {
        this.trainerUnsubscribe();
      }
      if (this.htUnsubscribe) {
        this.htUnsubscribe();
      }

      const trainerRef = db.collection("trainer");

      this.htUnsubscribe = trainerRef
        .where("isRetterpruefung", "==", true)
        .where("locationID", "array-contains", this.location)
        .orderBy("Name")
        .onSnapshot((snapshotChange) => {
          this.HT = [];
          snapshotChange.forEach((doc) => {
            this.HT.push({
              HTname: doc.data().Name,
            });
          });
        });

      this.trainerUnsubscribe = trainerRef
        .where("isRetter", "==", true)
        .where("locationID", "array-contains", this.location)
        .orderBy("Name")
        .onSnapshot((snapshotChange) => {
          this.trainer = [];
          snapshotChange.forEach((doc) => {
            this.trainer.push(this.mapTrainerDoc(doc));
          });
          this.loading = false;
        });
    },
    loadCriteria() {
      this.criteriaLoading = true;
      if (this.criteriaUnsubscribe) {
        this.criteriaUnsubscribe();
      }

      this.criteriaUnsubscribe = db
        .collection("retterpruefungskriterien")
        .doc(String(this.location))
        .onSnapshot(
          (doc) => {
            const data = doc.exists ? doc.data() : {};
            const rawCriteria = Array.isArray(data.criteria) ? data.criteria : [];

            this.criteria = rawCriteria
              .map((criterion, index) => ({
                localId: criterion.id || `${index}-${criterion.category || "Allgemein"}`,
                category: this.normalizeCriteriaCategory(criterion.category),
                criterion: criterion.criterion || criterion.text || "",
                errorPoints: Number(criterion.errorPoints || criterion.points || 0),
                sortOrder: Number(criterion.sortOrder || index),
              }))
              .filter((criterion) => criterion.criterion);

            this.failedCriteriaIds = this.failedCriteriaIds.filter((criterionId) =>
              this.criteria.some((criterion) => criterion.localId === criterionId)
            );
            if (!this.modals.criteria) {
              this.criteriaDraft = this.createCriteriaDraft(this.criteria);
            }
            this.criteriaLoading = false;
          },
          () => {
            this.criteria = [];
            this.criteriaLoading = false;
          }
        );
    },
    mapTrainerDoc(doc) {
      const data = doc.data();
      const checkDate = this.toDate(data.RetterpruefungDate);
      const firstAidDate = this.toDate(data.ErsteHilfeKursDatum);
      let status = null;
      let formattedCheckDate = "";

      if (checkDate) {
        const elapsedMs = Date.now() - checkDate.getTime();
        formattedCheckDate = moment(checkDate).format("DD.MM.YYYY").toString();

        if (
          data.isRetterLight === true &&
          elapsedMs < process.env.VUE_APP_RETTERSTATUS_INTERVALL_DAYS * 86400000
        ) {
          status = 4;
        } else if (
          elapsedMs < process.env.VUE_APP_RETTERSTATUS_WARNING_DAYS * 86400000
        ) {
          status = 1;
        } else if (
          elapsedMs > process.env.VUE_APP_RETTERSTATUS_WARNING_DAYS * 86400000 &&
          elapsedMs < process.env.VUE_APP_RETTERSTATUS_INTERVALL_DAYS * 86400000
        ) {
          status = 2;
        } else if (
          elapsedMs >= process.env.VUE_APP_RETTERSTATUS_INTERVALL_DAYS * 86400000
        ) {
          status = 3;
        }
      }

      let ersteHilfeKursExpired = false;
      let ersteHilfeKurs = "-";
      if (firstAidDate) {
        ersteHilfeKurs = moment(firstAidDate).format("MM/YYYY").toString();
        const ehkDatePlusXYears = moment(firstAidDate).add(
          process.env.VUE_APP_ERSTE_HILFE_KURSE_INTERVALL_YEARS,
          "years"
        );
        ersteHilfeKursExpired = ehkDatePlusXYears.isBefore(moment());
      }

      return {
        key: doc.id,
        trainerName: data.Name,
        trainerID: data.ID,
        trainerLetztePruefung: formattedCheckDate,
        trainerPruefer: data.RetterpruefungPruefer || "-",
        status,
        ersteHilfeKursDatum: ersteHilfeKurs,
        ersteHilfeKursExpired,
      };
    },
    createCriteriaDraft(criteria) {
      return criteria.map((criterion, index) => ({
        localId: criterion.localId || `draft-${index}-${Date.now()}`,
        id: criterion.id || criterion.localId || `criterion-${index + 1}`,
        category: this.normalizeCriteriaCategory(criterion.category),
        criterion: criterion.criterion || "",
        errorPoints: Number(criterion.errorPoints || 0),
        sortOrder: Number(criterion.sortOrder ?? index),
      }));
    },
    getSeedCriteriaForLocation(location) {
      const source = Array.isArray(criteriaSeedData[location]) ? criteriaSeedData[location] : [];
      return source.map((criterion, index) => ({
        localId: criterion.id || `seed-${location}-${index}`,
        id: criterion.id || `criterion-${index + 1}`,
        category: this.normalizeCriteriaCategory(criterion.category),
        criterion: criterion.criterion || "",
        errorPoints: Number(criterion.errorPoints || 0),
        sortOrder: Number(criterion.sortOrder ?? index),
      }));
    },
    normalizeCriteriaCategory(category) {
      const normalizedCategory = String(category || "").trim();
      const categoryMap = {
        Vorbereitung: "Einbau",
        Einbau: "Einbau",
        Aufstieg: "Aufstieg",
        "Lory-Aufstieg": "Aufstieg",
        Abseilen: "Abseilen",
        Rettung: "Elementrettung",
        Elementrettung: "Elementrettung",
        Plattformrettung: "Plattformrettung",
        Aktivrettung: "Aktivrettung",
        Kommunikation: "Sonstiges",
        Sonstiges: "Sonstiges",
        Allgemein: "Sonstiges",
      };

      return categoryMap[normalizedCategory] || "Sonstiges";
    },
    openCriteriaDialog() {
      this.criteriaDraft = this.createCriteriaDraft(this.criteria);
      this.modals.criteria = true;
    },
    closeCriteriaDialog() {
      this.modals.criteria = false;
      this.criteriaSaveInProgress = false;
      this.criteriaDraft = this.createCriteriaDraft(this.criteria);
    },
    loadSeedCriteria() {
      this.criteriaDraft = this.getSeedCriteriaForLocation(this.location);
    },
    addCriteriaRow() {
      this.criteriaDraft.push({
        localId: `new-${Date.now()}-${this.criteriaDraft.length}`,
        id: `criterion-${this.criteriaDraft.length + 1}`,
        category: "",
        criterion: "",
        errorPoints: 0,
        sortOrder: this.criteriaDraft.length,
      });
    },
    removeCriteriaRow(index) {
      this.criteriaDraft.splice(index, 1);
    },
    normalizeCriteriaDraft() {
      return this.criteriaDraft
        .filter(
          (criterion) =>
            String(criterion.category || "").trim() &&
            String(criterion.criterion || "").trim()
        )
        .map((criterion, index) => ({
          id: String(criterion.id || criterion.localId || `criterion-${index + 1}`),
          category: this.normalizeCriteriaCategory(criterion.category),
          criterion: String(criterion.criterion).trim(),
          errorPoints: Number(criterion.errorPoints || 0),
          sortOrder: index,
        }));
    },
    async saveCriteria() {
      if (!this.isCriteriaDraftValid) {
        return;
      }

      this.criteriaSaveInProgress = true;
      try {
        const normalizedCriteria = this.normalizeCriteriaDraft();
        await db.collection("retterpruefungskriterien").doc(String(this.location)).set(
          {
            locationID: this.location,
            criteria: normalizedCriteria,
            updatedAt: new Date(),
            updatedBy: store.getters.user.data ? store.getters.user.data.displayName : "Unbekannt",
          },
          { merge: true }
        );

        this.$notify({
          message: "Prüfkriterien wurden erfolgreich gespeichert.",
          icon: "fa fa-check-circle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "success",
          showClose: true,
          timeout: 5000,
        });
        this.modals.criteria = false;
      } catch (error) {
        this.$notify({
          message: "Prüfkriterien konnten nicht gespeichert werden.",
          icon: "fa fa-exclamation-triangle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "danger",
          showClose: true,
          timeout: 5000,
        });
      } finally {
        this.criteriaSaveInProgress = false;
      }
    },
    openAddCheckDialog(row) {
      this.selectedTrainer = row;
      this.newCheckDate = new Date();
      this.newCheckPruefer = this.currentUserName || null;
      this.newCheckComment = "";
      this.newCheckRescueType = "Passivrettung";
      this.useStopwatch = true;
      this.failedCriteriaIds = [];
      this.resetStopwatch();
      this.modals.addCheck = true;
    },
    closeAddCheckDialog() {
      this.pauseStopwatch();
      this.modals.addCheck = false;
      this.selectedTrainer = null;
      this.newCheckDate = null;
      this.newCheckPruefer = null;
      this.newCheckComment = "";
      this.newCheckRescueType = "Passivrettung";
      this.useStopwatch = false;
      this.failedCriteriaIds = [];
      this.stopwatchElapsedMs = 0;
      this.stopwatchStartedAt = null;
      this.stopwatchSplits = {
        loryAscent: null,
        ascent: null,
        rescue: null,
        rescuerGround: null,
      };
      this.resetSplitInputs();
    },
    async openHistoryDialog(row) {
      this.selectedTrainer = row;
      this.modals.history = true;
      this.historyLoading = true;
      this.historyEntries = [];

      try {
        const snapshot = await db
          .collection("trainer")
          .doc(row.key)
          .collection("retterpruefungen")
          .orderBy("date", "desc")
          .get();

        this.historyEntries = snapshot.docs.map((doc) => this.mapHistoryDoc(doc));
      } catch (error) {
        this.historyEntries = [];
        this.$notify({
          message: "Prüfungsverlauf konnte nicht geladen werden.",
          icon: "fa fa-exclamation-triangle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "danger",
          showClose: true,
          timeout: 5000,
        });
      } finally {
        this.historyLoading = false;
      }
    },
    closeHistoryDialog() {
      this.modals.history = false;
      this.historyEntries = [];
      this.historyLoading = false;
      this.selectedTrainer = null;
    },
    mapHistoryDoc(doc) {
      const data = doc.data();
      const times = data.times || {};
      const failedCriteria = Array.isArray(data.failedCriteria)
        ? data.failedCriteria.map((criterion, index) => ({
            key: criterion.id || `${doc.id}-${index}`,
            category: this.normalizeCriteriaCategory(criterion.category),
            criterion: criterion.criterion || "-",
            errorPoints: Number(criterion.errorPoints || 0),
          }))
        : [];
      const passed = typeof data.passed === "boolean" ? data.passed : data.result === "bestanden";

      return {
        key: doc.id,
        dateDisplay: this.formatHistoryDate(data.date || data.createdAt),
        pruefer: data.pruefer || "-",
        comment: data.comment || "",
        rescueType: data.rescueType || "Passivrettung",
        result: data.result || (passed ? "bestanden" : "nicht bestanden"),
        passed,
        totalErrorPoints: Number(data.totalErrorPoints || 0),
        totalTimeDisplay: this.formatStoredDuration(times.totalMs),
        times: {
          loryAscent: times.loryAscentMs ? this.formatStoredDuration(times.loryAscentMs) : "",
          ascent: this.formatStoredDuration(times.ascentMs),
          rescue: this.formatStoredDuration(times.rescueMs),
          rescuerGround: this.formatStoredDuration(times.rescuerGroundMs),
        },
        failedCriteria,
      };
    },
    formatHistoryDate(value) {
      const date = this.toDate(value);
      return date ? moment(date).format("DD.MM.YYYY") : "-";
    },
    startStopwatch() {
      if (this.stopwatchRunning) {
        return;
      }

      this.stopwatchStartedAt = Date.now() - this.stopwatchElapsedMs;
      this.stopwatchIntervalId = window.setInterval(() => {
        this.stopwatchElapsedMs = Date.now() - this.stopwatchStartedAt;
      }, 100);
      this.stopwatchRunning = true;
    },
    pauseStopwatch() {
      if (!this.stopwatchRunning) {
        return;
      }

      this.stopwatchElapsedMs = Date.now() - this.stopwatchStartedAt;
      window.clearInterval(this.stopwatchIntervalId);
      this.stopwatchIntervalId = null;
      this.stopwatchRunning = false;
    },
    toggleStopwatch() {
      if (!this.useStopwatch) {
        return;
      }
      if (this.stopwatchRunning) {
        this.pauseStopwatch();
        return;
      }
      this.startStopwatch();
    },
    handleStopwatchToggleChange() {
      if (!this.useStopwatch) {
        this.resetStopwatch();
      }
    },
    resetStopwatch() {
      this.pauseStopwatch();
      this.stopwatchElapsedMs = 0;
      this.stopwatchStartedAt = null;
      this.stopwatchSplits = {
        loryAscent: null,
        ascent: null,
        rescue: null,
        rescuerGround: null,
      };
      this.resetSplitInputs();
    },
    recordSplit(key) {
      if (!this.useStopwatch || !this.stopwatchElapsedMs) {
        return;
      }

      this.$set(this.stopwatchSplits, key, this.stopwatchElapsedMs);
      this.$set(this.splitInputValues, key, this.formatDuration(this.stopwatchElapsedMs));
      this.$set(this.splitInputErrors, key, false);
      if (key === this.getFinalSplitKey()) {
        this.pauseStopwatch();
      }
    },
    handleSplitInput(key) {
      const parsedDuration = this.parseDurationInput(this.splitInputValues[key]);

      if (parsedDuration === null) {
        this.$set(this.stopwatchSplits, key, null);
        this.$set(this.splitInputErrors, key, false);
        return;
      }

      if (Number.isNaN(parsedDuration)) {
        this.$set(this.splitInputErrors, key, true);
        return;
      }

      this.$set(this.stopwatchSplits, key, parsedDuration);
      this.$set(this.splitInputErrors, key, false);
    },
    parseDurationInput(value) {
      const normalizedValue = String(value || "").trim();
      if (!normalizedValue) {
        return null;
      }

      const match = normalizedValue.match(/^(\d+):(\d{1,2})(?:[.,](\d{1,2}))?$/);
      if (!match) {
        return Number.NaN;
      }

      const minutes = Number(match[1]);
      const seconds = Number(match[2]);
      const centiseconds = Number((match[3] || "0").padEnd(2, "0"));

      if (seconds >= 60 || centiseconds >= 100) {
        return Number.NaN;
      }

      return (minutes * 60000) + (seconds * 1000) + (centiseconds * 10);
    },
    resetSplitInputs() {
      this.splitInputValues = {
        loryAscent: "",
        ascent: "",
        rescue: "",
        rescuerGround: "",
      };
      this.splitInputErrors = {
        loryAscent: false,
        ascent: false,
        rescue: false,
        rescuerGround: false,
      };
    },
    getFinalSplitKey() {
      return this.requiresLoryTime ? "loryAscent" : "rescuerGround";
    },
    getFinalSplitValue() {
      return this.stopwatchSplits[this.getFinalSplitKey()];
    },
    hasSplitInputErrors() {
      return Object.values(this.splitInputErrors).some(Boolean);
    },
    getSplitDisplay(key) {
      const splitValue = this.stopwatchSplits[key];
      return splitValue !== null ? this.formatDuration(splitValue) : "-";
    },
    formatDuration(durationMs) {
      if (!durationMs && durationMs !== 0) {
        return "-";
      }

      const totalMilliseconds = Math.max(0, Number(durationMs));
      const totalSeconds = Math.floor(totalMilliseconds / 1000);
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      const centiseconds = Math.floor((totalMilliseconds % 1000) / 10);

      return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}.${String(centiseconds).padStart(2, "0")}`;
    },
    formatStoredDuration(durationMs) {
      if (durationMs === null || durationMs === undefined) {
        return "-";
      }
      return this.formatDuration(durationMs);
    },
    async addCheck() {
      if (!this.canSaveCheck) {
        return;
      }

      this.saveInProgress = true;

      try {
        const trainerRef = db.collection("trainer").doc(this.selectedTrainer.key);
        const historyRef = trainerRef.collection("retterpruefungen").doc();
        const passed = this.isCheckPassed;
        const totalMs = this.useStopwatch ? this.getFinalSplitValue() : null;
        const failedCriteria = this.selectedFailedCriteria.map((criterion) => ({
          id: criterion.localId,
          category: criterion.category,
          criterion: criterion.criterion,
          errorPoints: criterion.errorPoints,
        }));

        const payload = {
          date: this.newCheckDate,
          createdAt: new Date(),
          trainerId: this.selectedTrainer.trainerID || null,
          trainerName: this.selectedTrainer.trainerName,
          locationID: this.location,
          pruefer: this.newCheckPruefer,
          comment: String(this.newCheckComment || "").trim(),
          rescueType: this.newCheckRescueType,
          failedCriteria,
          totalErrorPoints: this.totalErrorPoints,
          maxErrorPoints: MAX_ERROR_POINTS,
          passed,
          result: passed ? "bestanden" : "nicht bestanden",
          times: {
            loryAscentMs: this.useStopwatch ? this.stopwatchSplits.loryAscent : null,
            ascentMs: this.useStopwatch ? this.stopwatchSplits.ascent : null,
            rescueMs: this.useStopwatch ? this.stopwatchSplits.rescue : null,
            rescuerGroundMs: this.useStopwatch ? this.stopwatchSplits.rescuerGround : null,
            totalMs,
          },
        };

        const batch = db.batch();
        batch.set(historyRef, payload);

        if (passed) {
          batch.update(trainerRef, {
            RetterpruefungPruefer: this.newCheckPruefer,
            RetterpruefungDate: this.newCheckDate,
            isRetterLight: false,
          });
        }

        await batch.commit();

        this.$notify({
          message: passed
            ? "Prüfung wurde erfolgreich gespeichert und als bestanden gewertet."
            : "Prüfung wurde gespeichert. Das Ergebnis ist nicht bestanden.",
          icon: passed ? "fa fa-check-circle" : "fa fa-exclamation-triangle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: passed ? "success" : "warning",
          showClose: true,
          timeout: 5000,
        });

        this.closeAddCheckDialog();
      } catch (error) {
        this.$notify({
          message: "Fehler beim Speichern der Prüfung. Bitte Internetverbindung prüfen.",
          icon: "fa fa-exclamation-triangle",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "danger",
          showClose: true,
          timeout: 5000,
        });
      } finally {
        this.saveInProgress = false;
      }
    },
  },
};
</script>

<style scoped>
.retterstatus-action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.retterstatus-action-buttons-left {
  justify-content: flex-start;
}

.retterstatus-modal-body {
  max-height: 70vh;
  overflow-y: auto;
}

.retterstatus-section {
  border-top: 1px solid #e6e6e6;
  padding-top: 1.5rem;
}

.retterstatus-summary {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.retterstatus-summary-compact {
  gap: 0.5rem;
}

.retterstatus-summary-item {
  background: #f4f4f4;
  border-radius: 999px;
  padding: 0.35rem 0.8rem;
}

.retterstatus-result {
  border-radius: 999px;
  color: #fff;
  font-size: 0.85rem;
  font-weight: 600;
  padding: 0.35rem 0.8rem;
  text-transform: uppercase;
}

.retterstatus-result-success {
  background: #2dce89;
}

.retterstatus-result-danger {
  background: #f5365c;
}

.retterstatus-empty-state {
  background: #f8f9fa;
  border: 1px dashed #d6d6d6;
  border-radius: 12px;
  color: #6c757d;
  margin-top: 1rem;
  padding: 1rem;
  text-align: center;
}

.retterstatus-criteria-group {
  background: #fafafa;
  border: 1px solid #ededed;
  border-radius: 14px;
  height: 100%;
  padding: 1rem;
}

.retterstatus-criteria-title {
  margin-bottom: 0.75rem;
}

.retterstatus-criteria-item {
  border-top: 1px solid #ececec;
  padding: 0.75rem 0;
}

.retterstatus-criteria-item:first-of-type {
  border-top: 0;
  padding-top: 0;
}

.retterstatus-checkbox-label {
  cursor: pointer;
  display: block;
}

.retterstatus-stopwatch-display {
  font-size: 2rem;
  font-variant-numeric: tabular-nums;
  font-weight: 700;
}

.retterstatus-stopwatch-display-disabled {
  color: #9aa4af;
}

.retterstatus-stopwatch-controls {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.retterstatus-toggle {
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  gap: 0.5rem;
}

.retterstatus-split-card {
  background: #fafafa;
  border: 1px solid #ededed;
  border-radius: 14px;
  margin-bottom: 1rem;
  padding: 1rem;
  text-align: center;
}

.retterstatus-split-label {
  color: #6c757d;
  font-size: 0.9rem;
}

.retterstatus-split-value {
  font-size: 1.5rem;
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  margin-top: 0.25rem;
}

.retterstatus-split-error {
  color: #f5365c;
  display: block;
  margin-top: 0.35rem;
}

.retterstatus-history-entry {
  background: #fafafa;
  border: 1px solid #ededed;
  border-radius: 14px;
  margin-bottom: 1rem;
  padding: 1rem;
}

.retterstatus-history-entry:last-child {
  margin-bottom: 0;
}

.retterstatus-history-metric {
  background: #fff;
  border: 1px solid #ededed;
  border-radius: 12px;
  margin-bottom: 0.75rem;
  padding: 0.75rem;
}

.retterstatus-history-comment {
  background: #fff;
  border: 1px solid #ededed;
  border-radius: 12px;
  padding: 0.75rem;
  white-space: pre-line;
}

.retterstatus-criteria-admin-header,
.retterstatus-criteria-admin-row {
  align-items: center;
  column-gap: 0.75rem;
  display: grid;
  grid-template-columns: 44px 1.1fr 2fr 140px 60px;
}

.retterstatus-criteria-admin-header {
  color: #6c757d;
  font-size: 0.85rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  padding: 0 0.25rem;
}

.retterstatus-criteria-admin-row {
  background: #fafafa;
  border: 1px solid #ededed;
  border-radius: 12px;
  margin-bottom: 0.75rem;
  padding: 0.75rem;
}

.retterstatus-criteria-admin-remove {
  display: flex;
  justify-content: flex-end;
}

.retterstatus-drag-column {
  display: flex;
  justify-content: center;
}

.retterstatus-drag-handle {
  align-items: center;
  background: #f1f3f5;
  border: 1px solid #dcdfe6;
  border-radius: 10px;
  color: #6c757d;
  cursor: grab;
  display: inline-flex;
  height: 40px;
  justify-content: center;
  padding: 0;
  width: 40px;
}

.retterstatus-drag-handle:active {
  cursor: grabbing;
}

.retterstatus-drag-ghost {
  opacity: 0.6;
}

.retterstatus-field-label {
  color: #6c757d;
  display: block;
  font-size: 0.8rem;
  margin-bottom: 0.35rem;
}

.retterstatus-mobile-only {
  display: none;
}

.retterstatus-radio-group {
  display: flex;
}

.retterstatus-radio-group ::v-deep .el-radio-button__inner {
  width: 100%;
}

@media (max-width: 767px) {
  .retterstatus-stopwatch-display {
    font-size: 1.6rem;
    margin-top: 0.75rem;
  }

  .retterstatus-summary {
    align-items: flex-start;
    flex-direction: column;
  }

  .retterstatus-criteria-admin-row {
    grid-template-columns: 1fr;
    row-gap: 0.75rem;
  }

  .retterstatus-mobile-only {
    display: block;
  }

}
</style>
